import {
    ApplicationConfig,
    LOCALE_ID,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';

import { routes } from './app.routes';
import { authInterceptor } from './features/auth/interceptors/auth.interceptor';
import {
    provideHttpClient,
    withFetch,
    withInterceptors,
} from '@angular/common/http';

// AB#9476 (UI-212): the UK locale is our single app-wide date/time default.
// Angular's built-in `date` pipe and Material's native date-adapter (the Bet
// History pickers) both key their format off LOCALE_ID; the framework ships
// 'en-US' by default, which renders and parses dates month-first (MM/DD/YYYY,
// 12h AM/PM). Registering + selecting 'en-GB' flips every locale-driven date
// surface to DD/MM/YYYY + 24h in one place, so bare pipes and pickers stay
// correct on future screens without per-screen format strings. Custom string
// formatters (FormatService.formatDateTime) are NOT locale-driven and are
// handled separately.
registerLocaleData(localeEnGb);

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: LOCALE_ID, useValue: 'en-GB' },
        provideBrowserGlobalErrorListeners(),
        provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
        // AB#8772: eventCoalescing defers post-event change detection to
        // requestAnimationFrame (~16ms). A fast decision/save request can
        // resolve — and navigate away — inside that frame, so a per-action
        // loading flag flips true→false before CD ever observes it and the
        // in-button spinner never renders. Run event CD synchronously so
        // loading feedback is reliable; these screens are light enough that
        // the extra CD per interaction is negligible.
        provideZoneChangeDetection({ eventCoalescing: false }),
        provideRouter(routes),
    ],
};
